import { defineStore } from 'pinia'

export interface GamePhaseState {
  showBar: boolean,
  speedPower: number,
  showSmallActionButtons: boolean,
  disabledSmallAction: boolean,
  showUi: boolean,
  mark: number,
  showRecords: boolean,
  showAngle: boolean,
  angle: number,
  angleColor: string
}

const initialState = (): GamePhaseState => ({
  showBar: false,
  speedPower: 0,
  showSmallActionButtons: true,
  disabledSmallAction: false,
  showUi: true,
  mark: 100,
  showRecords: false,
  showAngle: false,
  angle: 0,
  angleColor: ''
})

export const gamePhaseState = defineStore('gamePhaseState', {
  state: initialState
})
